import { Globals } from "./globals";
import * as XLSX from 'xlsx';

export class Utils {


    static String = {
        fillLeft(str: string, char: string, length: number): string {
            if(str.length >= length) return str;
            else return Utils.String.fillLeft(`${char}${str}`, char, length);
        },
        replaceAll: (str: string, oldChar: string, newChar: string) => {
            return str.replace(new RegExp(oldChar.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1"), 'g'), newChar);
        },
        random: (length: number, pos = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789') => {
            let ret = '';
            for(let i = 0; i < length; i++) ret += pos[Utils.Number.random(0, pos.length - 1)];
            return ret;
        },
        wildcardMatch: (fullStr: string, partStr: string, { capsSensitive = false } = {}) => {
            partStr = partStr.replace(/[-[\]{}()+?,\\^$|#\s]/g, '\\$&');
            let wildCardPatternStr = Utils.String.replaceAll(partStr, '*', '(.*?)');
            let regExp = capsSensitive ? new RegExp(wildCardPatternStr) : new RegExp(wildCardPatternStr, 'i');
            return fullStr.match(regExp);
        },
    };
    static Number = {
        random: (min: number, max: number) => {
            return Math.floor(Math.random()*((max + 1) - min)) + min;
        },
    };
    static Object = {
        keys: <T extends {[key: string]: any}>(obj: T): (keyof T)[] => Object.keys(obj),
    };
    static Time = {
        sleep: async (ms: number) => {
            await new Promise(resolve => setTimeout(resolve, ms));
        },
    }

    public static pickadateParams() {
        return [{
            format: 'yyyy-mm-dd',
            container: 'body',
            selectYears: 60,
            selectMonths: true,
            closeOnSelect: true,
            closeOnClear: false,//closeOnClear: true,
            today: 'Hoy',
            clear: 'Borrar fecha',
            close: 'Cerrar',
            onStart: function() {
                if (this.$node) {
                    this.$node.prop('readonly', true);
                    this.$node.on('mousedown', (e) => { e.preventDefault(); });
                }
            },
            monthsFull: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            weekdaysFull: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
            weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
            onOpen: function() {
                const textDiv = document.createElement('div');
                textDiv.setAttribute('class', 'picker__year');
                textDiv.style.color = '#fff';
                textDiv.style.fontSize = '16px';
                textDiv.style.fontWeight = '300';
                textDiv.innerHTML = this.$node[0].dataset.label;

                const containerDiv = document.createElement('div');
                containerDiv.setAttribute('class', 'picker__year-display');
                containerDiv.id = 'label-from-input';
                containerDiv.style.marginBottom = '8px';
                containerDiv.appendChild(textDiv);

                const pickadateLeftColumn = document.getElementsByClassName('picker__date-display')[0];
                if (pickadateLeftColumn) {
                    pickadateLeftColumn.insertBefore(containerDiv, pickadateLeftColumn.firstChild);
                }
            },
            onClose: function() {
                const containerDivCreated = document.getElementById('label-from-input');

                if (containerDivCreated !== null) {
                    containerDivCreated.remove();
                }
            },
        }];
    }

    public static convertDatefromStringtoISOString(dateToConvert) {
        return new Date(dateToConvert).toISOString().substring(0, 10);
    }

    public static convertDatefromISOStringtoObject(dateToConvert) {
        // new Date(year, month, day)

        return new Date(parseInt(dateToConvert.substring(0, 4)),
                        parseInt(dateToConvert.substring(5, 7)) - 1,
                        parseInt(dateToConvert.substring(8)));
    }

    public static convertDatefromStringtoObject(dateToConvert) {
        // new Date(year, month, day, hour, minute, second, millisecond)

        return new Date(parseInt(dateToConvert.substring(0, 4)),
                        parseInt(dateToConvert.substring(5, 7)) - 1,
                        parseInt(dateToConvert.substring(8, 10)),
                        parseInt(dateToConvert.substring(11, 13)),
                        parseInt(dateToConvert.substring(14, 16)),
                        parseInt(dateToConvert.substring(17),
                        0));
    }

    // params: XXXYYMMCCCC
    public static getNextFolio(folio) {
        console.log('folio: ' + folio);
        const currentDate = new Date();

        const currentYear = currentDate.getFullYear().toString().substring(2);
        const currentMonth = ('0' + (currentDate.getMonth() + 1)).slice(-2);

        let newFolio = 0;

        if (folio == '' || folio == null) {
            newFolio = parseInt(currentYear + currentMonth + '0001');
        } else {
            const folioMonth = folio.toString().substring(2, 4);

            if (currentMonth === folioMonth) {
                newFolio = (parseInt(folio) + 1);
            } else {
                newFolio = parseInt(currentYear + currentMonth + '0001');
            }
        }

        return newFolio;
    }

    public static pickatimeParams() {
        return [{
            format: 'HH:i',
            container: 'body',
            twelvehour: false,
            autoclose: true,
            donetext: 'Ok',
            cleartext: 'Borrar hora',
            canceltext: 'Cerrar',
            afterShow: function() {
                const inputClicked = document.getElementsByClassName('clockpicker picker picker--opened')[0];

                const textDiv = document.createElement('div');
                textDiv.setAttribute('class', 'clockpicker-display-column');
                textDiv.style.color = '#fff';
                textDiv.style.fontSize = '16px';
                textDiv.style.fontWeight = '300';
                textDiv.innerHTML = inputClicked.parentElement.getElementsByTagName('input')[0].dataset.label;

                const containerDiv = document.createElement('div');
                containerDiv.setAttribute('class', 'clockpicker-display');
                containerDiv.id = 'label-from-input';
                containerDiv.appendChild(textDiv);

                const pickatimeLeftColumn = inputClicked.getElementsByClassName('picker__date-display')[0];
                pickatimeLeftColumn.insertBefore(containerDiv, pickatimeLeftColumn.firstChild);
            },
            beforeHide: function() {
                const containerDivCreated = document.getElementById('label-from-input');

                if (containerDivCreated !== null) {
                    containerDivCreated.remove();
                }
            },
        }];
    }

    public static pickadateParamsNoBlank() {
        return [{
            format: 'yyyy-mm-dd',
            container: 'body',
            selectYears: 60,
            selectMonths: true,
            closeOnSelect: true,
            today: 'Hoy',
            clear: false,
            close: 'Cerrar',
            onStart: function() {
                if (this.$node) {
                    this.$node.prop('readonly', true);
                    this.$node.on('mousedown', (e) => { e.preventDefault(); });
                }
            },
            monthsFull: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            weekdaysFull: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
            weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
            onOpen: function() {
                const textDiv = document.createElement('div');
                textDiv.setAttribute('class', 'picker__year');
                textDiv.style.color = '#fff';
                textDiv.style.fontSize = '16px';
                textDiv.style.fontWeight = '300';
                textDiv.innerHTML = this.$node[0].dataset.label;

                const containerDiv = document.createElement('div');
                containerDiv.setAttribute('class', 'picker__year-display');
                containerDiv.id = 'label-from-input';
                containerDiv.style.marginBottom = '8px';
                containerDiv.appendChild(textDiv);

                const pickadateLeftColumn = document.getElementsByClassName('picker__date-display')[0];
                if (pickadateLeftColumn) {
                    pickadateLeftColumn.insertBefore(containerDiv, pickadateLeftColumn.firstChild);
                }
            },
            onClose: function() {
                const containerDivCreated = document.getElementById('label-from-input');

                if (containerDivCreated !== null) {
                    containerDivCreated.remove();
                }
            },
        }];
    }

    public static getDateWhitoutTime(dateToConvert) {
        const stringDate = new Date(dateToConvert);

        return stringDate.getFullYear() + '-' +
               ('0' + (stringDate.getMonth() + 1)).slice(-2) + '-' +
               ('0' + stringDate.getDate()).slice(-2);
    }

    public static getDateTime(dateToConvert) {
        const stringDate = new Date(dateToConvert);

        return stringDate.getFullYear() + '-' +
              ('0' + (stringDate.getMonth() + 1)).slice(-2) + '-' +
              ('0' + stringDate.getDate()).slice(-2) + ' ' +
              ('0' + stringDate.getHours()).slice(-2) + ':' +
              ('0' + stringDate.getMinutes()).slice(-2) + ':' +
              ('0' + stringDate.getSeconds()).slice(-2);
    }

    public static getDayMonthYearFromISODate(dateToConvert) {
        const year = dateToConvert.substring(0, 4);
        const month = dateToConvert.substring(5, 7);
        const day = dateToConvert.substring(8);

        let monthName;

        if (month === '01') { monthName = 'Enero'; }
        else if (month === '02') { monthName = 'Febrero'; }
        else if (month === '03') { monthName = 'Marzo'; }
        else if (month === '04') { monthName = 'Abril'; }
        else if (month === '05') { monthName = 'Mayo'; }
        else if (month === '06') { monthName = 'Junio'; }
        else if (month === '07') { monthName = 'Julio'; }
        else if (month === '08') { monthName = 'Agosto'; }
        else if (month === '09') { monthName = 'Septiembre'; }
        else if (month === '10') { monthName = 'Octubre'; }
        else if (month === '11') { monthName = 'Noviembre'; }
        else if (month === '12') { monthName = 'Diciembre'; }

        return (day + ' de ' + monthName + ' ' + year);
    }

    public static getWeekDayFromDates(arrayDates) {
        const daysWeek = [];

        for (let i in arrayDates) {
            const dayNum = new Date(arrayDates[i] + ' 12:00:00').getDay();
            let dayLet;

            if (dayNum === 0) { dayLet = 'D'; }
            else if (dayNum === 1) { dayLet = 'L'; }
            else if (dayNum === 2) { dayLet = 'M'; }
            else if (dayNum === 3) { dayLet = 'M'; }
            else if (dayNum === 4) { dayLet = 'J'; }
            else if (dayNum === 5) { dayLet = 'V'; }
            else if (dayNum === 6) { dayLet = 'S'; }

            daysWeek[i] = dayLet;
        }

        return daysWeek;
    }

    public static getPermissionModule([userObj], module) {
        const permissions = [];

        const iPermissions = userObj.permissions;

        for (let i in iPermissions) {
            if (iPermissions[i].id$ === module) {
                if (iPermissions[i].createAction === true) {
                    if (permissions.indexOf(iPermissions[i].id$ + '_' + 'C') === -1) {
                        permissions.push(iPermissions[i].id$ + '_' + 'C');
                    }
                }

                if (iPermissions[i].readAction === true) {
                    if (permissions.indexOf(iPermissions[i].id$ + '_' + 'R') === -1) {
                        permissions.push(iPermissions[i].id$ + '_' + 'R');
                    }
                }

                if (iPermissions[i].updateAction === true) {
                    if (permissions.indexOf(iPermissions[i].id$ + '_' + 'U') === -1) {
                        permissions.push(iPermissions[i].id$ + '_' + 'U');
                    }
                }

                if (iPermissions[i].deleteAction === true) {
                    if (permissions.indexOf(iPermissions[i].id$ + '_' + 'D') === -1) {
                        permissions.push(iPermissions[i].id$ + '_' + 'D');
                    }
                }
            }
        }

        return permissions;
    }

    /* public static leftChar(str: string, char: string, length: number): string {
        return str.length < length ? this.leftChar(`${char}${str}`, char, length) : str;
    } */

    public static objectArrayToCSV(objs: any[]): string {
        return objs.reduce((acc, cur) => `${acc}${
            this.array(cur).reduce((acc, [item]) => `${acc}${acc != '' ? ',' : ''}"${item}"`, '')
        }\r\n`,'data:text/csv;charset=utf-8,');
    }

    public static downloadCSV(rows: any[], title: string){
        let csv = this.objectArrayToCSV(rows);
        var encodedUri = encodeURI(csv);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        if(this.arrayLast(title.split('.')) != 'csv') title += '.csv';
        link.setAttribute("download", title);
        document.body.appendChild(link); // Required for FF
    
        link.click();
    }
    public static downloadExcel(rows: ({[key: string]: string} | string[])[], title: string){
         let aoa = rows.map(row => Object.values(row));
        //console.log(rows, aoa);
        let ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(aoa);
        let wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Reporte');
        if(this.arrayLast(title.split('.')) != 'xlsx') title += '.xlsx';
        XLSX.writeFile(wb, title);
    }
    public static async downloadAsJsonFile(object: any, title = 'download.json'){
        var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(object));
        var link = document.createElement("a");
        link.setAttribute("href", dataStr);
        if(this.arrayLast(title.split('.')) != 'json') title += '.json';
        link.setAttribute("download", title);
        document.body.appendChild(link);
        link.click();
        await new Promise(resolve => setTimeout(resolve, 10000));
        document.body.removeChild(link);
    }

    public static array<T extends {[key: string]: any}>(obj: T): [T[keyof T], keyof T][]{
        return Object.keys(obj).map((key: keyof T) => <any>[obj[key], key]);
    }

    static get today(): string {
        return this.stringDate();
    }
    static get time(): string {
        let d = new Date();
        let [hh, mm, ss] = [`${d.getHours()}`, `${d.getMinutes()}`, `${d.getSeconds()}`].map(s => this.String.fillLeft(s, '0', 2));
        return `${hh}:${mm}:${ss}`;
    }
    static get now(){
        let [year, month, day] = this.today.split('-');
        let [hours, minutes, seconds] = this.time.split(':');
        return {year, month, day, hours, minutes, seconds}
    }
    static stringDate(d:Date=new Date()): string {
        let dd = `${d.getDate()}`, mm = `${d.getMonth() + 1}`, yyyy = d.getFullYear();
        return `${yyyy}-${this.String.fillLeft(mm,'0',2)}-${this.String.fillLeft(dd,'0',2)}`;
    }
    static stringDatetime(d:Date=new Date()): string {
        let dd = `${d.getDate()}`, mm = `${d.getMonth() + 1}`, yyyy = d.getFullYear();
        let HH = `${d.getHours()}`, MM = `${d.getMinutes()}`, SS = `${d.getSeconds()}`;
        return `${yyyy}-${this.String.fillLeft(mm,'0',2)}-${this.String.fillLeft(dd,'0',2)}, ${this.String.fillLeft(HH,'0',2)}:${this.String.fillLeft(MM,'0',2)}:${this.String.fillLeft(SS,'0',2)}`;
    }
    static datetimeFromString(date: string, time: string = '00:00:00'){
        let [year, month, day] = date.split('-');
        let [hour, minute, second] = time.split(':');
        return new Date(+year, +month - 1, +day, +hour, +minute, +second);
    }
    static transformTimeStrTo24Format(time: string = '01:00PM'){
        let firstHalf = time.slice(0,5);
        let secondHalf = time.slice(5);
        let [HH, MM] = firstHalf.split(':');
        if(secondHalf == 'PM' && HH < '12') HH = this.String.fillLeft(`${+HH + 12}`, '0', 2);
        if(secondHalf == 'AM' && HH == '12') HH = '00';
        return `${HH}:${MM}`;
    }

    static arraySum(a1: (string | number)[], a2: (string | number)[], {money=false, exclude=[]}={}){
        if(a2.length > a1.length) [a1, a2] = [a2, a1];
        return a1.map((d, i) => {
            let {[i]: d2} = a2;
            if(typeof(d) == 'string') d = this.strToNumber(d);
            if(typeof(d2) == 'string') d2 = this.strToNumber(d2);
            return money && !exclude.includes(i) ? this.money(d + d2) : d + d2;
        });
    }
    static objSum(o1, o2){
        return Object.keys(o1).reduce((acc, key) => ({...acc, [key]: o1[key] + o2[key]}), {});
    }

    static money(value, onlyTwo = true){
		function locale(x){
			const xx = +x.toFixed(onlyTwo ? 2 : 4);
			return xx.toLocaleString('en-GB', { minimumFractionDigits: 4 });
		}
		function ceroes(xx){
			const x = xx + '';
			if(x.indexOf(".") == -1) return x + ".0000";
			else if(x.indexOf(".") == (x.length-5)) return x;
			else if(x.indexOf(".") == (x.length-4)) return x + '0';
			else if(x.indexOf(".") == (x.length-3)) return x + '00';
			else if(x.indexOf(".") == (x.length-2)) return x + '000';
			else if(x.indexOf(".") < (x.length-5)) return ceroes(x.slice(0,-1));
		}
		let ret = ceroes(locale(value));
		if(onlyTwo) ret = ret.substring(0, ret.length-2);
		return ret;
	}

    static getFile(url: string,){
        //let H = new Headers();
        //H.append("Access-Control-Allow-Headers", "x-requested-with, x-requested-by");
        console.log('fetch')
        return fetch(new Request(Globals.PROXY_URL + url)).then(r => {console.log(r); return r.status == 404 ? '' : r.text()}) // https://cors-anywhere.herokuapp.com/https://example.com
    }

    static async toDataUrl(url: string): Promise<string>{
        return new Promise((resolve: (value: string) => void) => {
            var xhr = new XMLHttpRequest();
            xhr.responseType = 'blob';
            xhr.onload = function() {
                var reader = new FileReader();
                reader.onloadend = function() {
                    resolve(<any> reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', Globals.PROXY_URL + url);
            xhr.send();

        })
    }

    static sort([...arr]: any[], keys: SortHeader[]){
        keys.reverse().map(({key, desc=false}) => {
            arr.sort((a,b) => {
                let c1, c2;
                if(!key.includes('.')){
                    c1 = a[key];
                    c2 = b[key]
                }else{
                    key.split('.').map(key => {
                        c1 = (c1 || a)[key];
                        c2 = (c2 || b)[key];
                    })
                }
                let c = desc ? c1 < c2 : c1 > c2;
                return c ? 1 : -1;
            });
        });
        return arr;
    }

    static throwAndAlert(error: any, msg: string): never {
        alert(msg);
        throw error;
    }

    /**
     * Removes chars that are not allowed from a string.
     * @param str
     * @param allowedChars 
     */
    static cleanString(str: string, allowedChars: string[]): string{
        let newStr = '';
        for(let char of str) if(allowedChars.includes(char)) newStr += char;
        return newStr;
    }

    //Random values
    static randomInt(min: number, max: number): number{
        return Math.round(
            Math.random()*(max - min) + min
        )
    }
    static randomString(length: number): string{
        let str = '';
        let possible = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        while(str.length < length) str += possible[this.randomInt(0, possible.length - 1)];
        return str;
    }

    //Data read and manipulation
    static arrayLast<T>(arr: T[]): T{
        return arr[arr.length - 1];
    }
    static arrayEquals(a1: any[], a2: any[], strict: boolean = false): boolean{
        return a1.length == a2.length && a1.every((item, index) => strict ? item === a2[index] : item == a2[index] );
    }
    static cleanPush<T>(a: T[], element: T): T{
        if(!a.includes(element)) a.push(element);
        return element;
      }
    static initials(text: string){
        return text.split(' ').reduce((acc, cur) => `${acc}${cur[0] || ''}`, '');
    }
    static strToNumber(str: any): number {
        if (str == null) return 0;
        if (typeof str === 'number') return str;
        let num = str.toString().replace(/,/g, '');
        return +num;
    }
    static numberBetween(number: number, min: number, max: number, equals: boolean = false): boolean{
        return equals ? number >= min && number <= max : number > min && number < max;
      }

}

export interface SortHeader { key: string, desc?: boolean };

